export default __webpack_public_path__ + "static/media/640_store03-fr-mobile.4614ccdb.png";